import { Plus } from 'lucide-react'
import { useState } from 'react'
import { copy } from '../../copy/investor-copy'
import { InviteWindow } from './invite-window'

/** The Following strip above the tabs: how to track a startup that is not on SeedForge yet. */
export function InviteStrip() {
  const [open, setOpen] = useState(false)
  return (
    <div className="flex flex-col gap-3 rounded-xl border border-border bg-card/30 px-4 py-3 sm:flex-row sm:items-center sm:justify-between">
      <div className="space-y-0.5">
        <p className="text-sm text-foreground">{copy('invite.strip.text')}</p>
        <p className="text-xs text-muted-foreground">{copy('invite.strip.note')}</p>
      </div>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="inline-flex h-8 shrink-0 items-center gap-1.5 self-start whitespace-nowrap rounded-lg bg-primary px-3 text-xs font-semibold text-primary-foreground transition-colors hover:bg-primary-hover sm:self-auto"
      >
        <Plus className="size-3.5" />
        <span>{copy('invite.strip.button')}</span>
      </button>
      {open && <InviteWindow open startup="" onClose={() => setOpen(false)} />}
    </div>
  )
}
